module.exports = __webpack_public_path__ + "static/media/login2.efbeda07.svg";